// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-bootstrap-index-js": () => import("/var/lib/jenkins/workspace/fox.uikit/fox.uikit.deploy.prod/src/pages/bootstrap/index.js" /* webpackChunkName: "component---src-pages-bootstrap-index-js" */),
  "component---src-pages-index-js": () => import("/var/lib/jenkins/workspace/fox.uikit/fox.uikit.deploy.prod/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-slds-index-js": () => import("/var/lib/jenkins/workspace/fox.uikit/fox.uikit.deploy.prod/src/pages/slds/index.js" /* webpackChunkName: "component---src-pages-slds-index-js" */)
}

